import gql from "graphql-tag";

export const AddClientUser = gql`
  mutation addCompanyUser($input: CompanyUserCreateInput!) {
    addCompanyUser(input: $input) {
      code
      message
      error
      data{
        companyUserCreated{
          company_user_email
          company_user_picture_url
          company_user_firstname
          company_user_lastname
          company_user_phone_number
          company_user_profil
          company_user_job
        }
      }
    }
  }
`;

export const VerifyEmailClient = gql`
  mutation clientVerifyAccount($input: ClientAccountVerifyAccount!) {
    clientVerifyAccount(input: $input) {
      message
      code
      error
      data {
        token
        account {
          first_name
          last_name
          email
          phone_number
          isVerified
          is_deleted
        }
      }
    }
  }
`;

export const ResetPasswordClient = gql`
  mutation clientResetPassword($input: ClientResetPasswordInput!) {
    clientResetPassword(input: $input) {
      message
      code
    }
  }
`;
export const ValidateAccountClient = gql`
  mutation clientValidateAccount($input: ClientAccountValidateAccountInput!) {
    clientValidateAccount(input: $input) {
      message
      code
      error
    }
  }
`;

export const UpdateCompanyUser = gql`
  mutation updateCompanyUser($input: CompanyUserUpdateInput!) {
    updateCompanyUser(input: $input) {
      message
      code
      error
    }
  }
`;

export const UserChangePassword = gql`
  mutation clientChangePassword($input: ClientChangePasswordInput!) {
    clientChangePassword(input: $input) {
      message
      code
    }
  }
`;
export const LogoutClient = gql`
  mutation clientLogout {
    clientLogout {
      message
      code
      error
    }
  }
`;

export const DeleteCompanyUser = gql`
  mutation deleteCompanyUser($input: CompanyUserDeleteInput!) {
    deleteCompanyUser(input: $input) {
      message
      code
    }
  }
`;
